import styled from 'styled-components';
import media from 'media';

const CenteredPanel = styled.div`
  position: fixed;
  width: auto;
  left: 50%;
  // right: 50%;
  top: 50%;
  // bottom: 50%;
  z-index: 2;
  white-space: normal;
  transform: translate(-50%, -50%);


  ${media.tablet`
    // position: fixed;
    // max-width: 90%;
    // top: auto;
    // bottom: 2%;
    // left: 50%;
    // transform: translateX(-50%);
  `}
`;

export default CenteredPanel;



// WEBPACK FOOTER //
// ./src/components/IntroPanel/CenteredPanel/CenteredPanel.js